// Purpose: CUI / classification banner shown along the bottom of
// full-bleed pages (sign-in today; Phase 8+ may add to others).
//
// Configurable per deployment via the `VITE_AST_COMPLIANCE_BANNER`
// env var. If the env var is unset, the component returns null — the
// banner does not render. This lets non-regulated deployments skip
// the banner without a code change.
//
// Per polish adjustment 2, the text color is
// `--compliance-banner-fg` (light #4B5563, dark #6B7A94), a tone
// between fg-secondary and fg-muted that reads as information
// rather than content.

const CLASSIFIER = import.meta.env.VITE_AST_COMPLIANCE_BANNER as string | undefined;

export interface ComplianceBannerProps {
  /** Override the env-var classifier string. Useful for per-page overrides. */
  classifier?: string;
  /** Right-side metadata (version, org). Optional. */
  version?: string;
  org?: string;
  className?: string;
}

export function ComplianceBanner({ classifier, version, org, className }: ComplianceBannerProps) {
  const label = classifier ?? CLASSIFIER;
  if (!label) return null;
  return (
    <footer
      className={[
        'absolute bottom-6 left-12 right-12 z-20',
        'flex items-center justify-between',
        'text-compliance uppercase text-compliance-fg',
        className ?? '',
      ].join(' ')}
    >
      <span>{label}</span>
      {version || org ? (
        <div className="flex items-center gap-5">
          {version ? <span>{version}</span> : null}
          {org ? <span>{org}</span> : null}
        </div>
      ) : null}
    </footer>
  );
}
